'use client'

import { useTranslations } from 'next-intl'

import { HighlightText } from '../../../../../components/HighlightText'

interface Props {
  venueName?: string | null
  venueEmail?: string | null
}

export function WithdrawalRequestedInfo({ venueName, venueEmail }: Props) {
  const translate = useTranslations('product-details')

  return (
    <div className="flex flex-col gap-2">
      <HighlightText
        variant="primary"
        title={translate('withdraw-requested-title')}
        description={translate('withdraw-requested-contact', {
          venueName: venueName ?? '',
          venueEmail: venueEmail ?? '',
        })}
      />
    </div>
  )
}
